<template>

  <div class="over">
    <!-- 弹出层 -->
    <el-dialog :visible.sync="sureDia" width="80%" center>
      <p style="font-size:12px;text-align:center;">Are you sure to deduct below amount?</p>
      <p class="num">{{num}}</p>
      <div slot="footer" class="dialog-footer">
        <div style="display:flex;justify-content: space-between;width:100%;">
          <div class="btn1" @click="sureDia = false">Cancel</div>
          <div class="btn2" type="primary" @click="sureSub()">Confirm</div>
        </div>

      </div>
    </el-dialog>
    <div v-if="loading" class="loadingMb">
      <div class="loading_box">
        <div class="load_item">
          <fade-loader :loading="loading" width="3px" height="3px" color="#ff9900"></fade-loader>
        </div>
        <p>Loading...</p>
      </div>
    </div>

    <img class="backBtn" @click="clickGoIndex" src="../assets/img/backIcon.png" alt />
    <div class="card" :style="'background-image: url('+giftCard.url+');'">
      <div class="mb">
        <p class="card_name">{{giftCard.name}}</p>
        <p class="card_date">{{giftCard.date}}</p>
        <p class="card_money">${{giftCard.money}}</p>

      </div>
      <div class="errLayer" v-if="giftCard.status!==0">
        <img src="../assets/img/pic/phone/lock拷贝.png" alt="">
        <p v-if="giftCard.status==1" class="errP">Locked</p>
        <p v-if="giftCard.status==2" class="errP">Expired</p>
      </div>
    </div>
    <div class="calculator" :class="giftCard.status==0?'':'noClick'">
      <div class="showTab">
        <p class="plz">Please enter amount</p>
        <p v-if="giftCard.status==0" class="num">{{num}}</p>
        <p v-if="giftCard.status!=0" class="num">N.A</p>
        <div class="hr"></div>
        <span v-if="isErr" class="vspan">*{{errMsg}}</span>
      </div>
      <div class="operateTab">
        <div class="row">
          <div class="item1" @click="numClick(7)">7</div>
          <div class="item1" @click="numClick(8)">8</div>
          <div class="item1" @click="numClick(9)">9</div>
          <div class="item1 cancel" @click="clickGoIndex">Cancel</div>
        </div>
        <div class="row">
          <div class="item1" @click="numClick(4)">4</div>
          <div class="item1" @click="numClick(5)">5</div>
          <div class="item1" @click="numClick(6)">6</div>
          <div class="item1 delete" @click="Delete()">Delete</div>
        </div>
        <div class="row">
          <div class="item1" @click="numClick(1)">1</div>
          <div class="item1" @click="numClick(2)">2</div>
          <div class="item1" @click="numClick(3)">3</div>
          <div class="item1 clear" @click="Clear()">Clear</div>
        </div>
        <div class="row" style="margin:3% 0">
          <div class="item1" @click="numClick(0)">0</div>
          <div class="item1" @click="numClick('00')">00</div>
          <div class="item2 submit" @click="Submit()">Submit</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    Toast,
  } from "mint-ui";
  import $ from "jquery";
   import {
    UseVoucher
  } from "@/api/account";

  import FadeLoader from 'vue-spinner/src/FadeLoader.vue';
  export default {
    data() {
      return {
        giftCard: {},
        num: "0.00",
        loading: false,
        sureDia: false,
        isErr: false,
        errMsg: ""
      };
    },
    components: {
      Toast,
      FadeLoader,
    },
    methods: {
      clickGoIndex() {
        this.$router.push("/");
      },
      numClick(n) {
        if (Number(this.num) === 0) {
          if (n === 0 || n === "00") {
            // console.log("点击0");
            return false;
          }
        }

        // 点击00
        if (n === "00") {
          let numArr = this.num.split('.')
          let numArr1 = numArr[0].toString()
          let numArr2 = numArr[1].toString().split("")
          if (numArr1.toString() === "0") {
            numArr1 = ""
          }
          let newNum = numArr1.toString() + numArr2[0].toString() + numArr2[1].toString() + "." + n.toString()
          let vNum = newNum.split("")
          if (vNum[0] == "0") {
            // console.log("第一项为0");
            newNum = newNum.substr(1)
          }
          // 验证大小
          if (Number(newNum) <= Number(this.giftCard.money)) {
            this.isErr = false

            this.num = newNum
            return false;
          } else {
            this.isErr = true
            this.errMsg = 'The amount is exceed';
            return false;
          }
        }
        // 其他
        let numArr = this.num.split('.')
        let numArr1 = numArr[0].toString()
        let numArr2 = numArr[1].toString().split("")
        if (numArr1.toString() === "0") {
          numArr1 = ""
        }
        let newNum = numArr1.toString() + numArr2[0].toString() + "." + numArr2[1].toString() + n.toString()
        // 验证大小
        // console.log(Number(newNum))
        // console.log(Number(this.giftCard.money))
        if (Number(newNum) <= Number(this.giftCard.money)) {
          this.isErr = false

          this.num = newNum
        } else {
          this.isErr = true
          this.errMsg = 'The amount is exceed';
        }
      },
      Delete() {
        if (this.num === "0.00") {
          // console.log("删空气");
          return false
        }
        this.isErr = false

        let numArr = this.num.split('.')
        let numArr2 = numArr[1].toString().split("")
        let numArr1 = numArr[0].toString().split("")
        let fstStr = numArr1[numArr[0].toString().length - 1]
        numArr2.unshift(fstStr)
        numArr2.pop()
        numArr1.pop()
        if (numArr1.length === 0) {
          // console.log("为空");
          numArr1.push(0)
        }
        // console.log(numArr1);
        // console.log(numArr2);
        let arrStr1 = "";
        for (let i = 0; i < numArr1.length; i++) {
          arrStr1 += numArr1[i]
        }
        let arrStr2 = "";
        for (let i = 0; i < numArr2.length; i++) {
          arrStr2 += numArr2[i]
        }
        let newNum = arrStr1 + "." + arrStr2
        // console.log(newNum);
        this.num = newNum

      },
      Clear() {
        if (this.num === "0.00") {
          return false
        }
        this.num = "0.00"
        this.isErr = false
      },
      Submit() {

        if (this.num == "0.00") {
          // this.$message({
          //   message: "The input amount cannot be empty",
          //   type: "warning",
          //   duration: 2000,
          //   showClose: true,
          //   center: true,
          // });
          // $(".item2").css("pointer-events", "none");
          // setTimeout(() => {
          //   $(".item2").css("pointer-events", "unset");
          // }, 2000)
          this.isErr = true
          this.errMsg = 'The input amount cannot be empty';
          return false
        }
        this.isErr = false
        this.sureDia = true;
      },
      async sureSub() {
        this.sureDia = false;
        this.loading = true;
        // 2021-09-14 请求核销
        
        const sn = this.giftCard.sn;
        const storeId = this.giftCard.storeId;
        const num = Math.ceil(Math.random() * 100000000).toString();
        const time = new Date().getTime().toString();
        const userTag = num + time;
        UseVoucher({
          sn,
          user_tag: userTag,
          store_id: storeId,
          amount: this.num,
          is_credit: 1
        }).then((data) => {
            let status = 0;
            if (data.code == 0) {
              status = 1;
            }
            let msg = data.msg;
            this.loading = false;
            this.$router.push({
              path: '/return',
              query: {
                status,
                msg
              }
            })
        }).catch((error) => {
          console.log(error)
          // 未知状态，先注释掉，后面放出
          //  this.$router.push({
          //     path: '/return',
          //     query: {
          //       status: 2,
          //       msg: 'Unknown Status',
          //       tag: userTag
          //     }
          //   })
        })
        
      },
    },

    created() {
    },

    mounted() {
      const params = this.$route.params;
      this.giftCard = params;
    }
  };
</script>

<style lang="less" scoped>
  @font-face {
    font-family: "Poppins-Light";
    src: url("../assets/font/Poppins-Light.ttf");
  }

  @font-face {
    font-family: "Poppins-Regular";
    src: url("../assets/font/Poppins-Regular.ttf");
  }

  @font-face {
    font-family: "Poppins-Medium";
    src: url("../assets/font/Poppins-SemiBold.ttf");
  }

  @font-face {
    font-family: "Poppins-SemiBold";
    src: url("../assets/font/Poppins-Bold.ttf");
  }

  /deep/.el-dialog {
    border-radius: 5px;
    margin-top: 35vh !important;
  }

  /deep/.el-dialog__header {
    display: none;
  }

  /deep/.el-message {
    font-family: Poppins-Regular !important;
  }

  /deep/.el-dialog--center .el-dialog__body {
    padding: 34px 12px 30px;

    .num {
      font-family: Poppins-Medium;
      font-size: 36px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 36px;
      letter-spacing: 1px;
      color: #211f1e;
      text-align: center;
      margin-top: 18px;
    }
  }

  /deep/.el-dialog--center .el-dialog__footer {
    display: flex;
    width: 82%;
    margin: auto;
    padding-top: 0;

    /deep/.dialog-footer {
      width: 100%;
    }

    .btn1 {
      width: 100px;
      height: 40px;
      background-color: #eeeeee;
      border-radius: 3px;
      line-height: 40px;
      text-align: center;
      font-family: Poppins-Regular;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #1c1c1c;
    }

    .btn2 {
      width: 100px;
      height: 40px;
      background-color: #1cce72;
      border-radius: 3px;
      line-height: 40px;
      text-align: center;
      font-family: Poppins-Regular;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #fff;
      margin-left: 16px;
    }
  }

  /deep/.dialog-footer {
    margin: auto;
  }

  .over {
    background: #eee;
    width: 100%;
    height: 100%;
    position: relative;

    .noClick {
      pointer-events: none;
    }

    .loadingMb {
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, .25);
      position: absolute;
      top: 0;
      left: 0;
      z-index: 500;

      .loading_box {
        width: 120px;
        height: 40px;
        background-color: rgba(0, 0, 0, .25);
        border-radius: 8px;
        position: absolute;
        display: flex;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 501;

        .load_item {
          display: block;
          width: 25px;
          height: 40px;
          margin-left: 15px;
          margin-top: 15px;
        }

        p {
          font-family: Poppins-Regular;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 40px;
          letter-spacing: 0px;
          color: #ffffff;
        }
      }
    }

    .backBtn {
      width: 6px;
      height: 12px;
      margin: 12px 0 0 12px;
    }

    .card {
      position: relative;
      width: 85%;
      height: 27%;
      margin: auto;
      margin-top: 16px;
      border-radius: 10px;
      background-size: 100% 100%;
      background-image: url('https://img2.baidu.com/it/u=476197612,4194353921&fm=15&fmt=auto&gp=0.jpg');

      .mb {
        width: 100%;
        height: 100%;
        border-radius: 10px;
        position: absolute;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, .30);
        z-index: 10;
        border-radius: 10px;

        .card_name {
          position: absolute;
          top: 12px;
          left: 12px;
          font-family: Poppins-Regular;
          font-size: 16px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 20px;
          letter-spacing: 0px;
          color: #ffffff;
          z-index: 10;
          margin-right: 12px;
        }

        .card_date {
          position: absolute;
          bottom: 12px;
          left: 12px;
          font-family: Poppins-Regular;
          font-size: 16px;
          letter-spacing: 0px;
          color: #ffffff;
          z-index: 10;

        }

        .card_money {
          position: absolute;
          bottom: 12px;
          right: 12px;
          font-family: Poppins-Medium;
          font-size: 20px;
          letter-spacing: 0px;
          color: #ffffff;
          z-index: 10;

        }


      }

      .errLayer {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, .65);
        z-index: 100;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border-radius: 10px;

        img {
          width: 48px;
          height: 48px;
        }

        .errP {
          font-family: Poppins-Medium;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          margin-top: 8px;
          letter-spacing: 0px;
          color: #ffffff;
        }
      }


    }

    .calculator {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 60%;
      box-shadow: 0px -2px 12px 0px #efefef;

      .showTab {
        background: #fff;
        border-radius: 10px 10px 0 0;
        height: 41.5%;

        .vspan {
          display: block;
          width: 85%;
          margin: auto;
          text-align: right;
          font-family: Poppins-Light;
          font-size: 12px;
          line-height: 15px;
          letter-spacing: 0px;
          color: #ff9900;
          margin-top: -2px;
        }

        .plz {
          width: 85%;
          margin: auto;
          font-family: Poppins-Regular;
          font-size: 14px;
          letter-spacing: 0px;
          color: #211f1e;
          padding-top: 9%;
        }

        .num {
          width: 85%;
          margin: auto;
          text-align: right;
          font-family: Poppins-Medium;
          font-size: 40px;
          letter-spacing: 1px;
          color: #211f1e;
          padding-top: 9%;
        }

        .hr {
          width: 85%;
          height: 2px;
          margin: auto;
          background-color: #f5f5f5;
          margin-top: 16px;
          margin-bottom: 5px;
        }
      }

      .operateTab {
        height: 55.5%;
        background-color: #eee;

        .row {
          display: flex;
          padding: 0 12px;
          justify-content: space-between;
          height: 19.4%;
          margin-top: 3%;

          .item1 {
            height: 100%;
            width: 21%;
            background-color: #ffffff;
            border-radius: 4px;
            text-align: center;
            display: flex;
            align-content: center;
            justify-content: center;
            align-items: center;
            font-family: Poppins-Medium;
            font-size: 18px;
            letter-spacing: 0px;
            color: #211f1e;
          }

          .item2 {
            height: 100%;
            width: 47%;
            background-color: #ffffff;
            border-radius: 4px;
            text-align: center;
            display: flex;
            align-content: center;
            justify-content: center;
            align-items: center;
            font-family: Poppins-Medium;
            font-size: 18px;
            letter-spacing: 0px;
            color: #211f1e;
          }

          .cancel {
            color: #fff;
            font-size: 14px;

            background-image: linear-gradient(#ff4949,
                #ff4949),
              linear-gradient(#000000,
                #000000);
            background-blend-mode: normal,
              normal;
          }

          .clear {
            color: #fff;
            font-size: 14px;
            background-color: #2f95fd;
          }

          .delete {
            color: #fff;
            font-size: 14px;

            background-color: #ff9900;
          }

          .submit {
            font-size: 14px;

            background-color: #1cce72;
            color: #fff;
          }
        }
      }
    }
  }
</style>